import React, { Fragment } from 'react';
import { useQuery } from '@apollo/react-hooks';

import { reduceContent } from '../globalUtils';
import { CONTENT_BY_PAGE } from '../../graphql';
import {
    InsuranceContainer
} from './index.style';

import Head from './Head';
import Top from './Top';
import Information from './Information';
import Packages from './Packages';
import Providers from './Providers';

import { Contact, Faqs, Loader } from '../Generic';
import { LeaveDetails } from './LeaveDetails';
import { useLocation, useHistory } from 'react-router-dom';
const page = 'insurance';

const Insurance = () => {
    const { hash } = useLocation();
    const { push } = useHistory();
    const formActive = hash === '#leaveDetails';
    const setFormActive = (active) => {
        if (active) {
            push('/insurance#leaveDetails');
        } else {
            push('/insurance');
        }
    };
    const { loading, error, data } = useQuery(CONTENT_BY_PAGE, {
        variables: {
            page,
            language: 'he',
        },
    });
    if (loading) {
        return <InsuranceContainer>
            <Loader />
        </InsuranceContainer>;
    }
    if (error) {
        return <InsuranceContainer>קרתה שגיאה</InsuranceContainer>;
    }
    const { contentByPage } = data;
    const reducedContent = reduceContent(contentByPage);

    const {
        head, top, risks, longTimeSavings, cars, packages, suppliers, form
    } = reducedContent;

    return <InsuranceContainer>
        {!!head && <Head head={head} page={page} />}
        {!formActive ? <Fragment>
            <Top
                top={top}
                setFormActive={setFormActive}
            />
            <Information
                top={top}
                risks={risks}
                longTimeSavings={longTimeSavings}
                cars={cars}
                setFormActive={setFormActive}
            />
            <Packages content={packages} setFormActive={setFormActive} />
            <Faqs category='INSURANCE' />
            <Providers
                setFormActive={setFormActive}
                content={suppliers}
            />
            <Contact />
        </Fragment> :
            <LeaveDetails
                content={form}
                setFormActive={setFormActive}
            />}
    </InsuranceContainer>;
};

export default Insurance;